module.exports = __webpack_public_path__ + "static/img/4-2.edcc891.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spark-go/mobile/4-2.png
// module id = hV3G
// module chunks = 12